let IOW = typeof window === 'undefined' ? undefined : require('../helpers/IntersectionObserver_screen__01');
module.exports = {
	bind: function (el, binding, vnode, oldVnode) {
		IOW.add(el, function () {
			return binding.value.apply(el, arguments);
		});
	},
	unbind: (el, binding, vnode, oldVnode) => IOW.del(el)
};
